<template>
  <div class="container">
    <div class="card">
      <!-- Formulario de datos -->
      <DataForm
        v-if="step == 0"
        :level="level"
        :old_user_data="user_data"
        :texts="texts"
        :type="type"
        @sendFormData="getFormData"
      />
      <!-- Para elegir cursos y horarios -->
      <Timetable
        v-if="step == 1"
        :user_id="user_id"
        :old_reservation="reservation"
        :texts="texts"
        :type="type"
        @sendReservationData="getReservation"
        @goOneStepBack="() => step--"
      />
      <!-- Formulario datos de facturación -->
      <el-form
        v-if="step == 2"
        :model="data_fact_form"
        label-position="top"
        ref="data_fact_form"
        :rules="data_fact_rules"
      >
        <div class="card-header bg-info">
          <h5 class="text-info">
            <i class="fas fa-info-circle"></i> ¿Por qué te pedimos los datos de facturación?
          </h5>
          <p class="text-info small m-0" v-html="texts['3_header']"></p>
        </div>

        <div class="card-body border-bottom bg-light">
          <h4 class="m-0">
            <i class="far fa-file-alt"></i> Datos de facturación
          </h4>
        </div>
        <div class="card-body">
          <div class="row">
            <div class="col-12 col-sm-6 col-md-4 col-lg">
              <el-checkbox
                v-if="user_data.birthdate && getAge() >= 18"
                @change="setFactForm()"
              >
                Utilizar mis datos anteriores
              </el-checkbox>
            </div>
          </div>
          <div class="row">
            <div class="col-12 col-sm-6 col-md-4 col-lg">
              <el-form-item label="Nombre de facturación" prop="name_fact">
                <div>
                  <el-input
                    placeholder="Nombre de facturación"
                    name="name"
                    v-model="data_fact_form.name_fact"
                  ></el-input>
                </div>
              </el-form-item>
            </div>
            <div class="col-12 col-sm-6 col-md-4 col-lg">
              <el-form-item label="NIF de facturación" prop="nif_fact">
                <div>
                  <el-input
                    placeholder="NIF de facturación"
                    name="nif"
                    v-model="data_fact_form.nif_fact"
                  ></el-input>
                </div>
              </el-form-item>
            </div>
            <div class="col-12 col-sm-6 col-md-4 col-lg">
              <el-form-item label="Teléfono de facturación" prop="phone_fact">
                <div>
                  <el-input
                    placeholder="Teléfono de facturación"
                    name="phone"
                    v-model="data_fact_form.phone_fact"
                  ></el-input>
                </div>
              </el-form-item>
            </div>
            <div class="col-12 col-sm-6 col-md-4 col-lg">
              <el-form-item label="Email de facturación" prop="email_fact">
                <template #label>
                  Email de facturación
                  <el-tooltip content="En caso de menores, el correo del estudiante no puede coincidir con el de facturación" placement="top" v-if="user_data.birthdate && getAge() < 18">
                    <i class="el-icon-info" style="margin-left: 5px; cursor: pointer; color: blue !important"></i>
                  </el-tooltip>
                </template>
                <div>
                  <el-input
                    placeholder="Email de facturación"
                    name="email"
                    v-model="data_fact_form.email_fact"
                  ></el-input>
                </div>
              </el-form-item>
            </div>
            <div class="col-12 col-md-8 col-lg-12">
              <el-form-item
                label="Dirección de facturación"
                prop="address_fact"
              >
                <div>
                  <el-input
                    placeholder="Dirección de facturación"
                    name="address"
                    v-model="data_fact_form.address_fact"
                  ></el-input>
                </div>
              </el-form-item>
            </div>
            <div class="col-12 col-md-8 col-lg-12">
              <el-form-item label="Observaciones" prop="observations">
                <div>
                  <el-input
                    placeholder="Indicar aquí cualquier detalle extra que debamos tener en cuenta"
                    name="notes"
                    v-model="data_fact_form.observations"
                    type="textarea"
                  ></el-input>
                </div>
              </el-form-item>
            </div>

            <div class="col-12 col-md-8 col-lg-12">
              <el-form-item prop="politics">
                <el-checkbox v-model="data_fact_form.politics" name="legal">
                  He leído y acepto la
                  <a href="/legal" target="_blank" rel="noopener noreferrer"
                    >Política de Privacidad</a
                  >
                </el-checkbox>
              </el-form-item>
              <div>
                <el-checkbox v-model="reservation.publicity" name="publicity">
                  Deseo recibir información puntual sobre otros cursos y talleres de London Calling. (El spam nos molesta tanto como a ti, así que no te daremos la lata, prometido)
                </el-checkbox>
              </div>
            </div>
          </div>
        </div>

        <div class="card-body bg-light border-top" style="display: flex; justify-content: space-between;">
          <el-button
            v-if="step > 0"
            style="width: 100%; max-width: 200px"
            type="primary"
            plain
            @click="step--"
            v-loading.fullscreen.lock="fullscreenLoading"
          >
            Atrás <i class="el-icon-arrow-left el-icon-left"></i>
          </el-button>
          <el-button
            style="width: 100%; max-width: 200px"
            type="primary"
            plain
            @click="sendFactData('data_fact_form')"
            v-loading.fullscreen.lock="fullscreenLoading"
          >
            Finalizar <i class="el-icon-arrow-right el-icon-right"></i>
          </el-button>
        </div>
      </el-form>
    </div>
  </div>
</template>

<script>
import DataForm from './DataForm.vue'
import Timetable from './Timetable.vue'

export default {
  props: ["level", "degree", "texts", "type"],
  components: {
    DataForm,
    Timetable
  },
  data() {
    return {
      step: 0,
      steps: {
        0: 'Formulario',
        1: 'Selección de cursos y horarios',
        2: 'Datos de facturación'
      },
      fullscreenLoading: false,
      fac_data: false, // Control para la visualización de los datos de facturación
      user_id: null,
      user_data: {
        name: "",
        surname: "",
        cif: "",
        birthdate: new Date(),
        email: "",
        phone: "",
        level: this.level ? this.level : "",
      },
      reservation: {
        userId: null,
        date: new Date(),
        course: null,
        timetables: null,
        mode: null,
        days: null,
        userExist: false,
        politics: false,
        publicity: false,
      },
      data_fact_form: {
        name_fact: "",
        nif_fact: "",
        phone_fact: null,
        email_fact: "",
        address_fact: "",
        observations: "",
      },
      reservation_id: null,
      degrees: [],
      data_fact_rules: {
        name_fact: [
          {
            required: true,
            message: "Por favor, introduce un nombre de facturación",
            trigger: "blur",
          },
        ],
        nif_fact: [
          {
            required: true,
            message: "Por favor, introduce un nif de facturación",
            trigger: "blur",
          },
        ],
        phone_fact: [
          {
            required: true,
            message: "Por favor, introduce un número de facturación",
            trigger: "blur",
          },
        ],
        email_fact: [
          {
            type: "email",
            required: true,
            message: "Por favor, introduce un correo de facturación",
            trigger: "blur",
          },
          {
            validator: (rule, value, callback) => {
              if (value === this.user_data.email && this.getAge() < 18) {
                callback(new Error("En caso de menores, el correo del estudiante no puede coincidir con el de facturación"));
              } else {
                callback();
              }
            },
            trigger: "blur",
          },
        ],
        address_fact: [
          {
            required: true,
            message: "Por favor, introduce una dirección de facturación",
            trigger: "blur",
          },
        ],
        politics: [
          {
            validator: (rule, value, callback) => {
              if (value === true) {
                callback();
              } else {
                callback(new Error("Debe aceptar las políticas de privacidad"));
                console.log("data_fact_rules");
              }
            },
            trigger: "blur",
          },
        ],
      },
    };
  },
  created() {
    const urlParams = new URLSearchParams(window.location.search);
    this.user_id = urlParams.get("user");
    this.reservation.userId = this.user_id;
    if (this.user_id && this.user_id != null && this.user_id !== undefined) {
      this.step = 1;
    }
    this.cleanUrl();
  },
  methods: {
    async getFormData(data, user_exists) {
      this.user_data = data
      this.reservation.userExist = user_exists;
      this.step = 1
    },
    async getReservation(reservation, sendForm = false) {
      this.reservation = reservation
      if (sendForm) {
        await this.sendFormReservation()
      }
      else {
        this.step = 2
      }
    },
    cleanUrl() {
      const url = new URL(window.location);
      url.searchParams.delete("user");
      window.history.replaceState({}, document.title, url.toString());
    },
    async sendBookingWithUser(reservation) {
      this.$refs[reservation].validate(async (valid) => {
        if (valid) {
          this.fullscreenLoading = true;
          await this.sendFormReservation();
        }
      });
    },
    getAge() {
      const birthDate = new Date(this.user_data.birthdate);
      const today = new Date();
      const age = today.getFullYear() - birthDate.getFullYear();

      if (
        today.getMonth() < birthDate.getMonth() ||
        (today.getMonth() === birthDate.getMonth() &&
          today.getDate() < birthDate.getDate())
      ) {
        return age - 1;
      }

      return age;
    },
    setFactForm() {
      this.data_fact_form.name_fact = this.user_data.name + " " + this.user_data.surname;
      this.data_fact_form.nif_fact = this.user_data.cif;
      this.data_fact_form.phone_fact = this.user_data.phone;
      this.data_fact_form.email_fact = this.user_data.email;
    },
    async sendFormReservation() {
      await axios
        .post("/api/store-booking", {
          user_id: this.user_id,
          name: this.user_data.name,
          surname: this.user_data.surname,
          cif: this.user_data.cif,
          birthdate: this.user_data.birthdate,
          email: this.user_data.email,
          smartphone: this.user_data.phone,
          level: this.user_data.level,
          level_id: this.degree,
          level_test: true,
          timetables: this.reservation.timetables,
          days: this.reservation.days,
          mode: this.reservation.mode,
          name_fact: this.data_fact_form.name_fact,
          nif_fact: this.data_fact_form.nif_fact,
          phone_fact: this.data_fact_form.phone_fact,
          email_fact: this.data_fact_form.email_fact,
          address_fact: this.data_fact_form.address_fact,
          observations: this.data_fact_form.observations,
          publicity: this.reservation.publicity,
          type: this.type,
        })
        .then((res) => {
          this.reservation_id = res.data;
          window.location.href = `/booking/${this.reservation_id}`;
        })
        .catch((e) => {
          this.fullscreenLoading = false;
          this.$message({
            message: e.response && e.response.data && e.response.data.message
              ? e.response.data.message
              : 'Error al enviar formulario, contacte con administración',
            type: "warning",
            duration: 5000,
          });
        });
    },
    sendFactData(data_fact_form) {
      this.$refs[data_fact_form].validate((valid) => {
        if (valid) {
          this.fullscreenLoading = true;
          this.sendFormReservation().catch((e) => {
            this.fullscreenLoading = false;
            this.$message({
              message: 'Error al enviar formulario, contacte con administración',
              type: "warning",
              duration: 5000,
            });
          });
        }
      });
    },
    changeDate() {
      return this.degrees.find((x) => x.id === this.reservation.course).finish;
    },
    changeForm(reservation) {
      this.$refs[reservation].validate((valid) => {
        if (valid) {
          if (this.reservation.userExist) {
            this.fullscreenLoading = true;
            this.sendFormReservation();
          }
          this.fac_data = true;
        }
      });
    },
  },
};
</script>
<style type="text/css" scoped>
.bg-info {
  background: #ecf5ff !important;
}
.text-info {
  color: #409eff !important;
}
</style>
